import classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'
import { ChoiceIndex } from '../../../../commons/ChoiceIndex'
import * as styles from './RealTimeAnswerChoice.css'

interface RealTimeAnswerChoiceProps {
  nowQuestion: any
  onChangeAnswerChoice: (data: any) => void
}

const RealTimeAnswerChoice: React.FunctionComponent<RealTimeAnswerChoiceProps> = ({
  nowQuestion,
  onChangeAnswerChoice
}) => {
  const choicesList = nowQuestion.choices
  const selectedAnswerChoiceId = nowQuestion.answer_choice_id
  const answerChoiceList = choicesList.map((choice: any, index: number) => {
    const choiceStyle =
      selectedAnswerChoiceId === choice.id ? classnames(styles.answerOption, styles.selected) : styles.answerOption
    return (
      <div
        key={`realtime-answer-choice-${index}`}
        className={choiceStyle}
        onClick={e => {
          onChangeAnswerChoice(choice.id)
        }}
      >
        {ChoiceIndex[index]}
      </div>
    )
  })
  return <div className={styles.container}>{answerChoiceList}</div>
}

export default compose<RealTimeAnswerChoiceProps, RealTimeAnswerChoiceProps>(pure)(RealTimeAnswerChoice)
